import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    containerUnitSelector: {
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      alignItems: "center",
    },
    containerSelectedSection: {
      display: "flex",
      flexDirection: "row",
    },
    containerAddButton: {
      borderRadius: `1px solid ${theme.palette.foreground.senary}`,
    },
    titleUnitType: {
      fontSize: "16px",
      fontWeight: 500,
      color: theme.palette.text.secondary,
      lineHeight: "24px",
      maxWidth: "200px",
      minWidth: "90px",
    },
    menuActiveIconClass: {
      fill: theme.palette.foreground.quarterary,
      cursor: "pointer",
      top: "0",
      right: "0",
    },
    menuDefaultIconClass: {
      fill: theme.palette.foreground.quinary,
      cursor: "pointer",
      top: "0",
      right: "0",
    },
    containerSelectedUnitType: {
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      flexWrap: "wrap",
    },
    containerUnitType: {
      display: "flex",
      flexDirection: "row",
      gap: "2px",
      border: `1px solid ${theme.palette.border.disabled}`,
      padding: "4px 6px 4px 10px",
      borderRadius: "8px",
      alignItems: "center",
      backgroundColor: theme.palette.background.paper
    },
    selectedUnitTypeTitle: {
      fontSize: "14px",
      fontWeight: 500,
      color: theme.palette.text.secondary,
      lineHeight: "20px",
    },
    wrapperAddUnitButton: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "8px",
      border: `1px solid ${theme.palette.border.disabled}`,
      backgroundColor: theme.palette.background.paper,
      borderRadius: "8px",
      "&:active": {
        boxShadow: `0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(152, 162, 179, 0.14)`,
      },
      "&:focus": {
        boxShadow: `0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(152, 162, 179, 0.14)`,
      },
    },
  };
});
